import React, {useEffect, useState} from 'react';
import {Amplify, Storage} from 'aws-amplify';
import aws_config from '../../modified_aws-export';
import {useTranslation} from "react-i18next";
import {IMatchModel} from "../../types/pinecone";
import {Card, Col, Form} from 'react-bootstrap';
import {copyFilenameToClipboard} from "../../utils/manualFinderUtils";
import {useExtractedImagesState} from "../../hooks";


interface DisplayMatchedImagesProps {
    oemImageName: string;
    matches: IMatchModel[];
}

const DisplayMatchedImages: React.FC<DisplayMatchedImagesProps> = ({ oemImageName, matches }) => {
    const [images, setImages] = useState<string[]>([]);
    const [checked, setChecked] = useState<boolean[]>(new Array(matches.length).fill(false));
    const {
        addToSelectedImages,
        removeFromSelectedImages,
        selectedImages,
        setDisplayImageManuals,
        displayImageManuals
    } = useExtractedImagesState()
    const { t } = useTranslation();

    Amplify.configure(aws_config);

    useEffect(() => {
        const fetchImages = async () => {
            const getMatchedImage = async (fileName: string) => {
                fileName = fileName.includes('OEM') ? fileName.replace('OEM', 'TA') : fileName;
                return await Storage.get(`processed_images/${fileName}.png`, {
                    bucket: aws_config.backend.bucket_name,
                    region: aws_config.backend.region,
                    level: 'public',
                    customPrefix: { public: '' },
                    validateObjectExistence: true
                });
            };

            const fetchedImages = await Promise.all(matches.map(async (match) => getMatchedImage(match.id)));
            setImages(fetchedImages);
        };

        fetchImages().catch(e => console.error(e));
    }, [matches]);

    useEffect(() => {
        const isDisplayManualsDetail = selectedImages.length > 0;
        setDisplayImageManuals(isDisplayManualsDetail);
        if (!isDisplayManualsDetail) {
            setChecked(new Array(matches.length).fill(false))
        }
    }, [selectedImages, setDisplayImageManuals, displayImageManuals, matches]);


  const handleCheckboxChange = (filename: string, index: number) => {
        const newChecked = [...checked];
        const isCurrentlyChecked = checked[index];
        const baseFilename = filename.split('.')[0];
        
        newChecked[index] = !isCurrentlyChecked;
        setChecked(newChecked);
        
        if (isCurrentlyChecked) {
            removeFromSelectedImages(baseFilename);
        } else {
            addToSelectedImages(baseFilename);
        }
    };

    return (
        <>
            {matches.map(({ id }, index) => {
                const FileName = id;
                const img = images[index];
                const isOEM = FileName.includes('OEM');
                const displayFileName = isOEM ? FileName.replace('OEM', 'TA') : FileName;

                return (
                    <Col className="mb-3" md={4} key={index}>
                        <Card className="h-100">
                            <div className="d-flex justify-content-end me-1">
                                <Form.Check
                                    type="checkbox"
                                    checked={checked[index]}
                                    onChange={() => handleCheckboxChange(FileName, index)}
                                    className="custom-checkbox"
                                />
                            </div>

                            <Card.Img variant="top" src={img} alt={`Matched ${index}`} />
                            <Card.Body className="d-flex flex-column align-items-center">
                                <Card.Text className="text-center"
                                    onDoubleClick={() => copyFilenameToClipboard(displayFileName, t("CopyToClipboardMessage"))}>
                                    {displayFileName}
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                );
            })}
        </>
    );
};

export default DisplayMatchedImages;
